import { j as P, h as tt, i as nt, u as rt, l as ot, B as ie, m as it, r as at } from "./UnstyledButton-ujNMaBde.js";
import H, { useReducer as st, useSyncExternalStore as ut, isValidElement as Ee, cloneElement as be, Children as ct, forwardRef as ft, useRef as Pe, useEffect as _e } from "react";
import { N as lt } from "./Notification-Do-uNydJ.js";
import { r as dt, b as pt, c as ht, O as vt, g as mt } from "./CloseButton-Bp_UJ8Gq.js";
import { _ as Be, a as yt, R as Ie } from "./objectWithoutPropertiesLoose-BPXq0dXk.js";
import { g as Et } from "./_commonjsHelpers-C6fGbg64.js";
import ve from "react-dom";
import './notifications.css';const bt = (e) => (e + 1) % 1e6;
function gt() {
  const [, e] = st(bt, 0);
  return e;
}
function xt(e) {
  let a = e, o = !1;
  const r = /* @__PURE__ */ new Set();
  return {
    getState() {
      return a;
    },
    updateState(n) {
      a = typeof n == "function" ? n(a) : n;
    },
    setState(n) {
      this.updateState(n), r.forEach((t) => t(a));
    },
    initialize(n) {
      o || (a = n, o = !0);
    },
    subscribe(n) {
      return r.add(n), () => r.delete(n);
    }
  };
}
function Tt(e) {
  return ut(
    e.subscribe,
    () => e.getState(),
    () => e.getState()
  );
}
function St(e, a, o) {
  const r = [], n = [], t = {};
  for (const i of e) {
    const u = i.position || a;
    t[u] = t[u] || 0, t[u] += 1, t[u] <= o ? n.push(i) : r.push(i);
  }
  return { notifications: n, queue: r };
}
const Ot = () => xt({
  notifications: [],
  queue: [],
  defaultPosition: "bottom-right",
  limit: 5
}), re = Ot(), Rt = (e = re) => Tt(e);
function ue(e, a) {
  const o = e.getState(), r = a([...o.notifications, ...o.queue]), n = St(r, o.defaultPosition, o.limit);
  e.setState({
    notifications: n.notifications,
    queue: n.queue,
    limit: o.limit,
    defaultPosition: o.defaultPosition
  });
}
function Ct(e, a = re) {
  const o = e.id || dt();
  return ue(a, (r) => e.id && r.some((n) => n.id === e.id) ? r : [...r, { ...e, id: o }]), o;
}
function Ge(e, a = re) {
  return ue(
    a,
    (o) => o.filter((r) => r.id === e ? (r.onClose?.(r), !1) : !0)
  ), e;
}
function Pt(e, a = re) {
  return ue(
    a,
    (o) => o.map((r) => r.id === e.id ? { ...r, ...e } : r)
  ), e.id;
}
function _t(e = re) {
  ue(e, () => []);
}
function wt(e = re) {
  ue(
    e,
    (a) => a.slice(0, e.getState().limit)
  );
}
const L = {
  show: Ct,
  hide: Ge,
  update: Pt,
  clean: _t,
  cleanQueue: wt,
  updateState: ue
};
function we(e, a) {
  return we = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(o, r) {
    return o.__proto__ = r, o;
  }, we(e, a);
}
function Xe(e, a) {
  e.prototype = Object.create(a.prototype), e.prototype.constructor = e, we(e, a);
}
var me = { exports: {} }, ye = { exports: {} }, R = {};
var De;
function jt() {
  if (De) return R;
  De = 1;
  var e = typeof Symbol == "function" && Symbol.for, a = e ? /* @__PURE__ */ Symbol.for("react.element") : 60103, o = e ? /* @__PURE__ */ Symbol.for("react.portal") : 60106, r = e ? /* @__PURE__ */ Symbol.for("react.fragment") : 60107, n = e ? /* @__PURE__ */ Symbol.for("react.strict_mode") : 60108, t = e ? /* @__PURE__ */ Symbol.for("react.profiler") : 60114, i = e ? /* @__PURE__ */ Symbol.for("react.provider") : 60109, u = e ? /* @__PURE__ */ Symbol.for("react.context") : 60110, l = e ? /* @__PURE__ */ Symbol.for("react.async_mode") : 60111, p = e ? /* @__PURE__ */ Symbol.for("react.concurrent_mode") : 60111, h = e ? /* @__PURE__ */ Symbol.for("react.forward_ref") : 60112, g = e ? /* @__PURE__ */ Symbol.for("react.suspense") : 60113, w = e ? /* @__PURE__ */ Symbol.for("react.suspense_list") : 60120, N = e ? /* @__PURE__ */ Symbol.for("react.memo") : 60115, D = e ? /* @__PURE__ */ Symbol.for("react.lazy") : 60116, M = e ? /* @__PURE__ */ Symbol.for("react.block") : 60121, A = e ? /* @__PURE__ */ Symbol.for("react.fundamental") : 60117, $ = e ? /* @__PURE__ */ Symbol.for("react.responder") : 60118, J = e ? /* @__PURE__ */ Symbol.for("react.scope") : 60119;
  function j(c) {
    if (typeof c == "object" && c !== null) {
      var U = c.$$typeof;
      switch (U) {
        case a:
          switch (c = c.type, c) {
            case l:
            case p:
            case r:
            case t:
            case n:
            case g:
              return c;
            default:
              switch (c = c && c.$$typeof, c) {
                case u:
                case h:
                case D:
                case N:
                case i:
                  return c;
                default:
                  return U;
              }
          }
        case o:
          return U;
      }
    }
  }
  function I(c) {
    return j(c) === p;
  }
  return R.AsyncMode = l, R.ConcurrentMode = p, R.ContextConsumer = u, R.ContextProvider = i, R.Element = a, R.ForwardRef = h, R.Fragment = r, R.Lazy = D, R.Memo = N, R.Portal = o, R.Profiler = t, R.StrictMode = n, R.Suspense = g, R.isAsyncMode = function(c) {
    return I(c) || j(c) === l;
  }, R.isConcurrentMode = I, R.isContextConsumer = function(c) {
    return j(c) === u;
  }, R.isContextProvider = function(c) {
    return j(c) === i;
  }, R.isElement = function(c) {
    return typeof c == "object" && c !== null && c.$$typeof === a;
  }, R.isForwardRef = function(c) {
    return j(c) === h;
  }, R.isFragment = function(c) {
    return j(c) === r;
  }, R.isLazy = function(c) {
    return j(c) === D;
  }, R.isMemo = function(c) {
    return j(c) === N;
  }, R.isPortal = function(c) {
    return j(c) === o;
  }, R.isProfiler = function(c) {
    return j(c) === t;
  }, R.isStrictMode = function(c) {
    return j(c) === n;
  }, R.isSuspense = function(c) {
    return j(c) === g;
  }, R.isValidElementType = function(c) {
    return typeof c == "string" || typeof c == "function" || c === r || c === p || c === t || c === n || c === g || c === w || typeof c == "object" && c !== null && (c.$$typeof === D || c.$$typeof === N || c.$$typeof === i || c.$$typeof === u || c.$$typeof === h || c.$$typeof === A || c.$$typeof === $ || c.$$typeof === J || c.$$typeof === M);
  }, R.typeOf = j, R;
}
var C = {};
var $e;
function Mt() {
  return $e || ($e = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = typeof Symbol == "function" && Symbol.for, a = e ? /* @__PURE__ */ Symbol.for("react.element") : 60103, o = e ? /* @__PURE__ */ Symbol.for("react.portal") : 60106, r = e ? /* @__PURE__ */ Symbol.for("react.fragment") : 60107, n = e ? /* @__PURE__ */ Symbol.for("react.strict_mode") : 60108, t = e ? /* @__PURE__ */ Symbol.for("react.profiler") : 60114, i = e ? /* @__PURE__ */ Symbol.for("react.provider") : 60109, u = e ? /* @__PURE__ */ Symbol.for("react.context") : 60110, l = e ? /* @__PURE__ */ Symbol.for("react.async_mode") : 60111, p = e ? /* @__PURE__ */ Symbol.for("react.concurrent_mode") : 60111, h = e ? /* @__PURE__ */ Symbol.for("react.forward_ref") : 60112, g = e ? /* @__PURE__ */ Symbol.for("react.suspense") : 60113, w = e ? /* @__PURE__ */ Symbol.for("react.suspense_list") : 60120, N = e ? /* @__PURE__ */ Symbol.for("react.memo") : 60115, D = e ? /* @__PURE__ */ Symbol.for("react.lazy") : 60116, M = e ? /* @__PURE__ */ Symbol.for("react.block") : 60121, A = e ? /* @__PURE__ */ Symbol.for("react.fundamental") : 60117, $ = e ? /* @__PURE__ */ Symbol.for("react.responder") : 60118, J = e ? /* @__PURE__ */ Symbol.for("react.scope") : 60119;
    function j(f) {
      return typeof f == "string" || typeof f == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      f === r || f === p || f === t || f === n || f === g || f === w || typeof f == "object" && f !== null && (f.$$typeof === D || f.$$typeof === N || f.$$typeof === i || f.$$typeof === u || f.$$typeof === h || f.$$typeof === A || f.$$typeof === $ || f.$$typeof === J || f.$$typeof === M);
    }
    function I(f) {
      if (typeof f == "object" && f !== null) {
        var W = f.$$typeof;
        switch (W) {
          case a:
            var he = f.type;
            switch (he) {
              case l:
              case p:
              case r:
              case t:
              case n:
              case g:
                return he;
              default:
                var Ae = he && he.$$typeof;
                switch (Ae) {
                  case u:
                  case h:
                  case D:
                  case N:
                  case i:
                    return Ae;
                  default:
                    return W;
                }
            }
          case o:
            return W;
        }
      }
    }
    var c = l, U = p, ce = u, Z = i, oe = a, pe = h, K = r, z = D, fe = N, Y = o, X = t, q = n, V = g, F = !1;
    function le(f) {
      return F || (F = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), s(f) || I(f) === l;
    }
    function s(f) {
      return I(f) === p;
    }
    function d(f) {
      return I(f) === u;
    }
    function x(f) {
      return I(f) === i;
    }
    function E(f) {
      return typeof f == "object" && f !== null && f.$$typeof === a;
    }
    function m(f) {
      return I(f) === h;
    }
    function T(f) {
      return I(f) === r;
    }
    function y(f) {
      return I(f) === D;
    }
    function b(f) {
      return I(f) === N;
    }
    function S(f) {
      return I(f) === o;
    }
    function _(f) {
      return I(f) === t;
    }
    function O(f) {
      return I(f) === n;
    }
    function k(f) {
      return I(f) === g;
    }
    C.AsyncMode = c, C.ConcurrentMode = U, C.ContextConsumer = ce, C.ContextProvider = Z, C.Element = oe, C.ForwardRef = pe, C.Fragment = K, C.Lazy = z, C.Memo = fe, C.Portal = Y, C.Profiler = X, C.StrictMode = q, C.Suspense = V, C.isAsyncMode = le, C.isConcurrentMode = s, C.isContextConsumer = d, C.isContextProvider = x, C.isElement = E, C.isForwardRef = m, C.isFragment = T, C.isLazy = y, C.isMemo = b, C.isPortal = S, C.isProfiler = _, C.isStrictMode = O, C.isSuspense = k, C.isValidElementType = j, C.typeOf = I;
  })()), C;
}
var qe;
function Qe() {
  return qe || (qe = 1, process.env.NODE_ENV === "production" ? ye.exports = jt() : ye.exports = Mt()), ye.exports;
}
var xe, ke;
function Nt() {
  if (ke) return xe;
  ke = 1;
  var e = Object.getOwnPropertySymbols, a = Object.prototype.hasOwnProperty, o = Object.prototype.propertyIsEnumerable;
  function r(t) {
    if (t == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(t);
  }
  function n() {
    try {
      if (!Object.assign)
        return !1;
      var t = new String("abc");
      if (t[5] = "de", Object.getOwnPropertyNames(t)[0] === "5")
        return !1;
      for (var i = {}, u = 0; u < 10; u++)
        i["_" + String.fromCharCode(u)] = u;
      var l = Object.getOwnPropertyNames(i).map(function(h) {
        return i[h];
      });
      if (l.join("") !== "0123456789")
        return !1;
      var p = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(h) {
        p[h] = h;
      }), Object.keys(Object.assign({}, p)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return xe = n() ? Object.assign : function(t, i) {
    for (var u, l = r(t), p, h = 1; h < arguments.length; h++) {
      u = Object(arguments[h]);
      for (var g in u)
        a.call(u, g) && (l[g] = u[g]);
      if (e) {
        p = e(u);
        for (var w = 0; w < p.length; w++)
          o.call(u, p[w]) && (l[p[w]] = u[p[w]]);
      }
    }
    return l;
  }, xe;
}
var Te, Ye;
function Me() {
  if (Ye) return Te;
  Ye = 1;
  var e = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return Te = e, Te;
}
var Se, Le;
function Je() {
  return Le || (Le = 1, Se = Function.call.bind(Object.prototype.hasOwnProperty)), Se;
}
var Oe, ze;
function At() {
  if (ze) return Oe;
  ze = 1;
  var e = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var a = /* @__PURE__ */ Me(), o = {}, r = /* @__PURE__ */ Je();
    e = function(t) {
      var i = "Warning: " + t;
      typeof console < "u" && console.error(i);
      try {
        throw new Error(i);
      } catch {
      }
    };
  }
  function n(t, i, u, l, p) {
    if (process.env.NODE_ENV !== "production") {
      for (var h in t)
        if (r(t, h)) {
          var g;
          try {
            if (typeof t[h] != "function") {
              var w = Error(
                (l || "React class") + ": " + u + " type `" + h + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[h] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw w.name = "Invariant Violation", w;
            }
            g = t[h](i, h, l, u, null, a);
          } catch (D) {
            g = D;
          }
          if (g && !(g instanceof Error) && e(
            (l || "React class") + ": type specification of " + u + " `" + h + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof g + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), g instanceof Error && !(g.message in o)) {
            o[g.message] = !0;
            var N = p ? p() : "";
            e(
              "Failed " + u + " type: " + g.message + (N ?? "")
            );
          }
        }
    }
  }
  return n.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (o = {});
  }, Oe = n, Oe;
}
var Re, Fe;
function It() {
  if (Fe) return Re;
  Fe = 1;
  var e = Qe(), a = Nt(), o = /* @__PURE__ */ Me(), r = /* @__PURE__ */ Je(), n = /* @__PURE__ */ At(), t = function() {
  };
  process.env.NODE_ENV !== "production" && (t = function(u) {
    var l = "Warning: " + u;
    typeof console < "u" && console.error(l);
    try {
      throw new Error(l);
    } catch {
    }
  });
  function i() {
    return null;
  }
  return Re = function(u, l) {
    var p = typeof Symbol == "function" && Symbol.iterator, h = "@@iterator";
    function g(s) {
      var d = s && (p && s[p] || s[h]);
      if (typeof d == "function")
        return d;
    }
    var w = "<<anonymous>>", N = {
      array: $("array"),
      bigint: $("bigint"),
      bool: $("boolean"),
      func: $("function"),
      number: $("number"),
      object: $("object"),
      string: $("string"),
      symbol: $("symbol"),
      any: J(),
      arrayOf: j,
      element: I(),
      elementType: c(),
      instanceOf: U,
      node: pe(),
      objectOf: Z,
      oneOf: ce,
      oneOfType: oe,
      shape: z,
      exact: fe
    };
    function D(s, d) {
      return s === d ? s !== 0 || 1 / s === 1 / d : s !== s && d !== d;
    }
    function M(s, d) {
      this.message = s, this.data = d && typeof d == "object" ? d : {}, this.stack = "";
    }
    M.prototype = Error.prototype;
    function A(s) {
      if (process.env.NODE_ENV !== "production")
        var d = {}, x = 0;
      function E(T, y, b, S, _, O, k) {
        if (S = S || w, O = O || b, k !== o) {
          if (l) {
            var f = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw f.name = "Invariant Violation", f;
          } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
            var W = S + ":" + b;
            !d[W] && // Avoid spamming the console because they are often not actionable except for lib authors
            x < 3 && (t(
              "You are manually calling a React.PropTypes validation function for the `" + O + "` prop on `" + S + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), d[W] = !0, x++);
          }
        }
        return y[b] == null ? T ? y[b] === null ? new M("The " + _ + " `" + O + "` is marked as required " + ("in `" + S + "`, but its value is `null`.")) : new M("The " + _ + " `" + O + "` is marked as required in " + ("`" + S + "`, but its value is `undefined`.")) : null : s(y, b, S, _, O);
      }
      var m = E.bind(null, !1);
      return m.isRequired = E.bind(null, !0), m;
    }
    function $(s) {
      function d(x, E, m, T, y, b) {
        var S = x[E], _ = q(S);
        if (_ !== s) {
          var O = V(S);
          return new M(
            "Invalid " + T + " `" + y + "` of type " + ("`" + O + "` supplied to `" + m + "`, expected ") + ("`" + s + "`."),
            { expectedType: s }
          );
        }
        return null;
      }
      return A(d);
    }
    function J() {
      return A(i);
    }
    function j(s) {
      function d(x, E, m, T, y) {
        if (typeof s != "function")
          return new M("Property `" + y + "` of component `" + m + "` has invalid PropType notation inside arrayOf.");
        var b = x[E];
        if (!Array.isArray(b)) {
          var S = q(b);
          return new M("Invalid " + T + " `" + y + "` of type " + ("`" + S + "` supplied to `" + m + "`, expected an array."));
        }
        for (var _ = 0; _ < b.length; _++) {
          var O = s(b, _, m, T, y + "[" + _ + "]", o);
          if (O instanceof Error)
            return O;
        }
        return null;
      }
      return A(d);
    }
    function I() {
      function s(d, x, E, m, T) {
        var y = d[x];
        if (!u(y)) {
          var b = q(y);
          return new M("Invalid " + m + " `" + T + "` of type " + ("`" + b + "` supplied to `" + E + "`, expected a single ReactElement."));
        }
        return null;
      }
      return A(s);
    }
    function c() {
      function s(d, x, E, m, T) {
        var y = d[x];
        if (!e.isValidElementType(y)) {
          var b = q(y);
          return new M("Invalid " + m + " `" + T + "` of type " + ("`" + b + "` supplied to `" + E + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return A(s);
    }
    function U(s) {
      function d(x, E, m, T, y) {
        if (!(x[E] instanceof s)) {
          var b = s.name || w, S = le(x[E]);
          return new M("Invalid " + T + " `" + y + "` of type " + ("`" + S + "` supplied to `" + m + "`, expected ") + ("instance of `" + b + "`."));
        }
        return null;
      }
      return A(d);
    }
    function ce(s) {
      if (!Array.isArray(s))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? t(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : t("Invalid argument supplied to oneOf, expected an array.")), i;
      function d(x, E, m, T, y) {
        for (var b = x[E], S = 0; S < s.length; S++)
          if (D(b, s[S]))
            return null;
        var _ = JSON.stringify(s, function(k, f) {
          var W = V(f);
          return W === "symbol" ? String(f) : f;
        });
        return new M("Invalid " + T + " `" + y + "` of value `" + String(b) + "` " + ("supplied to `" + m + "`, expected one of " + _ + "."));
      }
      return A(d);
    }
    function Z(s) {
      function d(x, E, m, T, y) {
        if (typeof s != "function")
          return new M("Property `" + y + "` of component `" + m + "` has invalid PropType notation inside objectOf.");
        var b = x[E], S = q(b);
        if (S !== "object")
          return new M("Invalid " + T + " `" + y + "` of type " + ("`" + S + "` supplied to `" + m + "`, expected an object."));
        for (var _ in b)
          if (r(b, _)) {
            var O = s(b, _, m, T, y + "." + _, o);
            if (O instanceof Error)
              return O;
          }
        return null;
      }
      return A(d);
    }
    function oe(s) {
      if (!Array.isArray(s))
        return process.env.NODE_ENV !== "production" && t("Invalid argument supplied to oneOfType, expected an instance of array."), i;
      for (var d = 0; d < s.length; d++) {
        var x = s[d];
        if (typeof x != "function")
          return t(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + F(x) + " at index " + d + "."
          ), i;
      }
      function E(m, T, y, b, S) {
        for (var _ = [], O = 0; O < s.length; O++) {
          var k = s[O], f = k(m, T, y, b, S, o);
          if (f == null)
            return null;
          f.data && r(f.data, "expectedType") && _.push(f.data.expectedType);
        }
        var W = _.length > 0 ? ", expected one of type [" + _.join(", ") + "]" : "";
        return new M("Invalid " + b + " `" + S + "` supplied to " + ("`" + y + "`" + W + "."));
      }
      return A(E);
    }
    function pe() {
      function s(d, x, E, m, T) {
        return Y(d[x]) ? null : new M("Invalid " + m + " `" + T + "` supplied to " + ("`" + E + "`, expected a ReactNode."));
      }
      return A(s);
    }
    function K(s, d, x, E, m) {
      return new M(
        (s || "React class") + ": " + d + " type `" + x + "." + E + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + m + "`."
      );
    }
    function z(s) {
      function d(x, E, m, T, y) {
        var b = x[E], S = q(b);
        if (S !== "object")
          return new M("Invalid " + T + " `" + y + "` of type `" + S + "` " + ("supplied to `" + m + "`, expected `object`."));
        for (var _ in s) {
          var O = s[_];
          if (typeof O != "function")
            return K(m, T, y, _, V(O));
          var k = O(b, _, m, T, y + "." + _, o);
          if (k)
            return k;
        }
        return null;
      }
      return A(d);
    }
    function fe(s) {
      function d(x, E, m, T, y) {
        var b = x[E], S = q(b);
        if (S !== "object")
          return new M("Invalid " + T + " `" + y + "` of type `" + S + "` " + ("supplied to `" + m + "`, expected `object`."));
        var _ = a({}, x[E], s);
        for (var O in _) {
          var k = s[O];
          if (r(s, O) && typeof k != "function")
            return K(m, T, y, O, V(k));
          if (!k)
            return new M(
              "Invalid " + T + " `" + y + "` key `" + O + "` supplied to `" + m + "`.\nBad object: " + JSON.stringify(x[E], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(s), null, "  ")
            );
          var f = k(b, O, m, T, y + "." + O, o);
          if (f)
            return f;
        }
        return null;
      }
      return A(d);
    }
    function Y(s) {
      switch (typeof s) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !s;
        case "object":
          if (Array.isArray(s))
            return s.every(Y);
          if (s === null || u(s))
            return !0;
          var d = g(s);
          if (d) {
            var x = d.call(s), E;
            if (d !== s.entries) {
              for (; !(E = x.next()).done; )
                if (!Y(E.value))
                  return !1;
            } else
              for (; !(E = x.next()).done; ) {
                var m = E.value;
                if (m && !Y(m[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function X(s, d) {
      return s === "symbol" ? !0 : d ? d["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && d instanceof Symbol : !1;
    }
    function q(s) {
      var d = typeof s;
      return Array.isArray(s) ? "array" : s instanceof RegExp ? "object" : X(d, s) ? "symbol" : d;
    }
    function V(s) {
      if (typeof s > "u" || s === null)
        return "" + s;
      var d = q(s);
      if (d === "object") {
        if (s instanceof Date)
          return "date";
        if (s instanceof RegExp)
          return "regexp";
      }
      return d;
    }
    function F(s) {
      var d = V(s);
      switch (d) {
        case "array":
        case "object":
          return "an " + d;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + d;
        default:
          return d;
      }
    }
    function le(s) {
      return !s.constructor || !s.constructor.name ? w : s.constructor.name;
    }
    return N.checkPropTypes = n, N.resetWarningCache = n.resetWarningCache, N.PropTypes = N, N;
  }, Re;
}
var Ce, We;
function Dt() {
  if (We) return Ce;
  We = 1;
  var e = /* @__PURE__ */ Me();
  function a() {
  }
  function o() {
  }
  return o.resetWarningCache = a, Ce = function() {
    function r(i, u, l, p, h, g) {
      if (g !== e) {
        var w = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw w.name = "Invariant Violation", w;
      }
    }
    r.isRequired = r;
    function n() {
      return r;
    }
    var t = {
      array: r,
      bigint: r,
      bool: r,
      func: r,
      number: r,
      object: r,
      string: r,
      symbol: r,
      any: r,
      arrayOf: n,
      element: r,
      elementType: r,
      instanceOf: n,
      node: r,
      objectOf: n,
      oneOf: n,
      oneOfType: n,
      shape: n,
      exact: n,
      checkPropTypes: o,
      resetWarningCache: a
    };
    return t.PropTypes = t, t;
  }, Ce;
}
var Ue;
function $t() {
  if (Ue) return me.exports;
  if (Ue = 1, process.env.NODE_ENV !== "production") {
    var e = Qe(), a = !0;
    me.exports = /* @__PURE__ */ It()(e.isElement, a);
  } else
    me.exports = /* @__PURE__ */ Dt()();
  return me.exports;
}
var qt = /* @__PURE__ */ $t();
const v = /* @__PURE__ */ Et(qt), Ve = {
  disabled: !1
};
var kt = process.env.NODE_ENV !== "production" ? v.oneOfType([v.number, v.shape({
  enter: v.number,
  exit: v.number,
  appear: v.number
}).isRequired]) : null;
process.env.NODE_ENV !== "production" && v.oneOfType([v.string, v.shape({
  enter: v.string,
  exit: v.string,
  active: v.string
}), v.shape({
  enter: v.string,
  enterDone: v.string,
  enterActive: v.string,
  exit: v.string,
  exitDone: v.string,
  exitActive: v.string
})]);
const ge = H.createContext(null);
var Yt = function(a) {
  return a.scrollTop;
}, de = "unmounted", ee = "exited", te = "entering", se = "entered", je = "exiting", B = /* @__PURE__ */ (function(e) {
  Xe(a, e);
  function a(r, n) {
    var t;
    t = e.call(this, r, n) || this;
    var i = n, u = i && !i.isMounting ? r.enter : r.appear, l;
    return t.appearStatus = null, r.in ? u ? (l = ee, t.appearStatus = te) : l = se : r.unmountOnExit || r.mountOnEnter ? l = de : l = ee, t.state = {
      status: l
    }, t.nextCallback = null, t;
  }
  a.getDerivedStateFromProps = function(n, t) {
    var i = n.in;
    return i && t.status === de ? {
      status: ee
    } : null;
  };
  var o = a.prototype;
  return o.componentDidMount = function() {
    this.updateStatus(!0, this.appearStatus);
  }, o.componentDidUpdate = function(n) {
    var t = null;
    if (n !== this.props) {
      var i = this.state.status;
      this.props.in ? i !== te && i !== se && (t = te) : (i === te || i === se) && (t = je);
    }
    this.updateStatus(!1, t);
  }, o.componentWillUnmount = function() {
    this.cancelNextCallback();
  }, o.getTimeouts = function() {
    var n = this.props.timeout, t, i, u;
    return t = i = u = n, n != null && typeof n != "number" && (t = n.exit, i = n.enter, u = n.appear !== void 0 ? n.appear : i), {
      exit: t,
      enter: i,
      appear: u
    };
  }, o.updateStatus = function(n, t) {
    if (n === void 0 && (n = !1), t !== null)
      if (this.cancelNextCallback(), t === te) {
        if (this.props.unmountOnExit || this.props.mountOnEnter) {
          var i = this.props.nodeRef ? this.props.nodeRef.current : ve.findDOMNode(this);
          i && Yt(i);
        }
        this.performEnter(n);
      } else
        this.performExit();
    else this.props.unmountOnExit && this.state.status === ee && this.setState({
      status: de
    });
  }, o.performEnter = function(n) {
    var t = this, i = this.props.enter, u = this.context ? this.context.isMounting : n, l = this.props.nodeRef ? [u] : [ve.findDOMNode(this), u], p = l[0], h = l[1], g = this.getTimeouts(), w = u ? g.appear : g.enter;
    if (!n && !i || Ve.disabled) {
      this.safeSetState({
        status: se
      }, function() {
        t.props.onEntered(p);
      });
      return;
    }
    this.props.onEnter(p, h), this.safeSetState({
      status: te
    }, function() {
      t.props.onEntering(p, h), t.onTransitionEnd(w, function() {
        t.safeSetState({
          status: se
        }, function() {
          t.props.onEntered(p, h);
        });
      });
    });
  }, o.performExit = function() {
    var n = this, t = this.props.exit, i = this.getTimeouts(), u = this.props.nodeRef ? void 0 : ve.findDOMNode(this);
    if (!t || Ve.disabled) {
      this.safeSetState({
        status: ee
      }, function() {
        n.props.onExited(u);
      });
      return;
    }
    this.props.onExit(u), this.safeSetState({
      status: je
    }, function() {
      n.props.onExiting(u), n.onTransitionEnd(i.exit, function() {
        n.safeSetState({
          status: ee
        }, function() {
          n.props.onExited(u);
        });
      });
    });
  }, o.cancelNextCallback = function() {
    this.nextCallback !== null && (this.nextCallback.cancel(), this.nextCallback = null);
  }, o.safeSetState = function(n, t) {
    t = this.setNextCallback(t), this.setState(n, t);
  }, o.setNextCallback = function(n) {
    var t = this, i = !0;
    return this.nextCallback = function(u) {
      i && (i = !1, t.nextCallback = null, n(u));
    }, this.nextCallback.cancel = function() {
      i = !1;
    }, this.nextCallback;
  }, o.onTransitionEnd = function(n, t) {
    this.setNextCallback(t);
    var i = this.props.nodeRef ? this.props.nodeRef.current : ve.findDOMNode(this), u = n == null && !this.props.addEndListener;
    if (!i || u) {
      setTimeout(this.nextCallback, 0);
      return;
    }
    if (this.props.addEndListener) {
      var l = this.props.nodeRef ? [this.nextCallback] : [i, this.nextCallback], p = l[0], h = l[1];
      this.props.addEndListener(p, h);
    }
    n != null && setTimeout(this.nextCallback, n);
  }, o.render = function() {
    var n = this.state.status;
    if (n === de)
      return null;
    var t = this.props, i = t.children;
    t.in, t.mountOnEnter, t.unmountOnExit, t.appear, t.enter, t.exit, t.timeout, t.addEndListener, t.onEnter, t.onEntering, t.onEntered, t.onExit, t.onExiting, t.onExited, t.nodeRef;
    var u = Be(t, ["children", "in", "mountOnEnter", "unmountOnExit", "appear", "enter", "exit", "timeout", "addEndListener", "onEnter", "onEntering", "onEntered", "onExit", "onExiting", "onExited", "nodeRef"]);
    return (
      // allows for nested Transitions
      /* @__PURE__ */ H.createElement(ge.Provider, {
        value: null
      }, typeof i == "function" ? i(n, u) : H.cloneElement(H.Children.only(i), u))
    );
  }, a;
})(H.Component);
B.contextType = ge;
B.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * A React reference to DOM element that need to transition:
   * https://stackoverflow.com/a/51127130/4671932
   *
   *   - When `nodeRef` prop is used, `node` is not passed to callback functions
   *      (e.g. `onEnter`) because user already has direct access to the node.
   *   - When changing `key` prop of `Transition` in a `TransitionGroup` a new
   *     `nodeRef` need to be provided to `Transition` with changed `key` prop
   *     (see
   *     [test/CSSTransition-test.js](https://github.com/reactjs/react-transition-group/blob/13435f897b3ab71f6e19d724f145596f5910581c/test/CSSTransition-test.js#L362-L437)).
   */
  nodeRef: v.shape({
    current: typeof Element > "u" ? v.any : function(e, a, o, r, n, t) {
      var i = e[a];
      return v.instanceOf(i && "ownerDocument" in i ? i.ownerDocument.defaultView.Element : Element)(e, a, o, r, n, t);
    }
  }),
  /**
   * A `function` child can be used instead of a React element. This function is
   * called with the current transition status (`'entering'`, `'entered'`,
   * `'exiting'`, `'exited'`), which can be used to apply context
   * specific props to a component.
   *
   * ```jsx
   * <Transition in={this.state.in} timeout={150}>
   *   {state => (
   *     <MyComponent className={`fade fade-${state}`} />
   *   )}
   * </Transition>
   * ```
   */
  children: v.oneOfType([v.func.isRequired, v.element.isRequired]).isRequired,
  /**
   * Show the component; triggers the enter or exit states
   */
  in: v.bool,
  /**
   * By default the child component is mounted immediately along with
   * the parent `Transition` component. If you want to "lazy mount" the component on the
   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
   * mounted, even on "exited", unless you also specify `unmountOnExit`.
   */
  mountOnEnter: v.bool,
  /**
   * By default the child component stays mounted after it reaches the `'exited'` state.
   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
   */
  unmountOnExit: v.bool,
  /**
   * By default the child component does not perform the enter transition when
   * it first mounts, regardless of the value of `in`. If you want this
   * behavior, set both `appear` and `in` to `true`.
   *
   * > **Note**: there are no special appear states like `appearing`/`appeared`, this prop
   * > only adds an additional enter transition. However, in the
   * > `<CSSTransition>` component that first enter transition does result in
   * > additional `.appear-*` classes, that way you can choose to style it
   * > differently.
   */
  appear: v.bool,
  /**
   * Enable or disable enter transitions.
   */
  enter: v.bool,
  /**
   * Enable or disable exit transitions.
   */
  exit: v.bool,
  /**
   * The duration of the transition, in milliseconds.
   * Required unless `addEndListener` is provided.
   *
   * You may specify a single timeout for all transitions:
   *
   * ```jsx
   * timeout={500}
   * ```
   *
   * or individually:
   *
   * ```jsx
   * timeout={{
   *  appear: 500,
   *  enter: 300,
   *  exit: 500,
   * }}
   * ```
   *
   * - `appear` defaults to the value of `enter`
   * - `enter` defaults to `0`
   * - `exit` defaults to `0`
   *
   * @type {number | { enter?: number, exit?: number, appear?: number }}
   */
  timeout: function(a) {
    var o = kt;
    a.addEndListener || (o = o.isRequired);
    for (var r = arguments.length, n = new Array(r > 1 ? r - 1 : 0), t = 1; t < r; t++)
      n[t - 1] = arguments[t];
    return o.apply(void 0, [a].concat(n));
  },
  /**
   * Add a custom transition end trigger. Called with the transitioning
   * DOM node and a `done` callback. Allows for more fine grained transition end
   * logic. Timeouts are still used as a fallback if provided.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * ```jsx
   * addEndListener={(node, done) => {
   *   // use the css transitionend event to mark the finish of a transition
   *   node.addEventListener('transitionend', done, false);
   * }}
   * ```
   */
  addEndListener: v.func,
  /**
   * Callback fired before the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEnter: v.func,
  /**
   * Callback fired after the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: v.func,
  /**
   * Callback fired after the "entered" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEntered: v.func,
  /**
   * Callback fired before the "exiting" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExit: v.func,
  /**
   * Callback fired after the "exiting" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExiting: v.func,
  /**
   * Callback fired after the "exited" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExited: v.func
} : {};
function ae() {
}
B.defaultProps = {
  in: !1,
  mountOnEnter: !1,
  unmountOnExit: !1,
  appear: !1,
  enter: !0,
  exit: !0,
  onEnter: ae,
  onEntering: ae,
  onEntered: ae,
  onExit: ae,
  onExiting: ae,
  onExited: ae
};
B.UNMOUNTED = de;
B.EXITED = ee;
B.ENTERING = te;
B.ENTERED = se;
B.EXITING = je;
function Lt(e) {
  if (e === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function Ne(e, a) {
  var o = function(t) {
    return a && Ee(t) ? a(t) : t;
  }, r = /* @__PURE__ */ Object.create(null);
  return e && ct.map(e, function(n) {
    return n;
  }).forEach(function(n) {
    r[n.key] = o(n);
  }), r;
}
function zt(e, a) {
  e = e || {}, a = a || {};
  function o(h) {
    return h in a ? a[h] : e[h];
  }
  var r = /* @__PURE__ */ Object.create(null), n = [];
  for (var t in e)
    t in a ? n.length && (r[t] = n, n = []) : n.push(t);
  var i, u = {};
  for (var l in a) {
    if (r[l])
      for (i = 0; i < r[l].length; i++) {
        var p = r[l][i];
        u[r[l][i]] = o(p);
      }
    u[l] = o(l);
  }
  for (i = 0; i < n.length; i++)
    u[n[i]] = o(n[i]);
  return u;
}
function ne(e, a, o) {
  return o[a] != null ? o[a] : e.props[a];
}
function Ft(e, a) {
  return Ne(e.children, function(o) {
    return be(o, {
      onExited: a.bind(null, o),
      in: !0,
      appear: ne(o, "appear", e),
      enter: ne(o, "enter", e),
      exit: ne(o, "exit", e)
    });
  });
}
function Wt(e, a, o) {
  var r = Ne(e.children), n = zt(a, r);
  return Object.keys(n).forEach(function(t) {
    var i = n[t];
    if (Ee(i)) {
      var u = t in a, l = t in r, p = a[t], h = Ee(p) && !p.props.in;
      l && (!u || h) ? n[t] = be(i, {
        onExited: o.bind(null, i),
        in: !0,
        exit: ne(i, "exit", e),
        enter: ne(i, "enter", e)
      }) : !l && u && !h ? n[t] = be(i, {
        in: !1
      }) : l && u && Ee(p) && (n[t] = be(i, {
        onExited: o.bind(null, i),
        in: p.props.in,
        exit: ne(i, "exit", e),
        enter: ne(i, "enter", e)
      }));
    }
  }), n;
}
var Ut = Object.values || function(e) {
  return Object.keys(e).map(function(a) {
    return e[a];
  });
}, Vt = {
  component: "div",
  childFactory: function(a) {
    return a;
  }
}, Q = /* @__PURE__ */ (function(e) {
  Xe(a, e);
  function a(r, n) {
    var t;
    t = e.call(this, r, n) || this;
    var i = t.handleExited.bind(Lt(t));
    return t.state = {
      contextValue: {
        isMounting: !0
      },
      handleExited: i,
      firstRender: !0
    }, t;
  }
  var o = a.prototype;
  return o.componentDidMount = function() {
    this.mounted = !0, this.setState({
      contextValue: {
        isMounting: !1
      }
    });
  }, o.componentWillUnmount = function() {
    this.mounted = !1;
  }, a.getDerivedStateFromProps = function(n, t) {
    var i = t.children, u = t.handleExited, l = t.firstRender;
    return {
      children: l ? Ft(n, u) : Wt(n, i, u),
      firstRender: !1
    };
  }, o.handleExited = function(n, t) {
    var i = Ne(this.props.children);
    n.key in i || (n.props.onExited && n.props.onExited(t), this.mounted && this.setState(function(u) {
      var l = yt({}, u.children);
      return delete l[n.key], {
        children: l
      };
    }));
  }, o.render = function() {
    var n = this.props, t = n.component, i = n.childFactory, u = Be(n, ["component", "childFactory"]), l = this.state.contextValue, p = Ut(this.state.children).map(i);
    return delete u.appear, delete u.enter, delete u.exit, t === null ? /* @__PURE__ */ H.createElement(ge.Provider, {
      value: l
    }, p) : /* @__PURE__ */ H.createElement(ge.Provider, {
      value: l
    }, /* @__PURE__ */ H.createElement(t, u, p));
  }, a;
})(H.Component);
Q.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * `<TransitionGroup>` renders a `<div>` by default. You can change this
   * behavior by providing a `component` prop.
   * If you use React v16+ and would like to avoid a wrapping `<div>` element
   * you can pass in `component={null}`. This is useful if the wrapping div
   * borks your css styles.
   */
  component: v.any,
  /**
   * A set of `<Transition>` components, that are toggled `in` and out as they
   * leave. the `<TransitionGroup>` will inject specific transition props, so
   * remember to spread them through if you are wrapping the `<Transition>` as
   * with our `<Fade>` example.
   *
   * While this component is meant for multiple `Transition` or `CSSTransition`
   * children, sometimes you may want to have a single transition child with
   * content that you want to be transitioned out and in when you change it
   * (e.g. routes, images etc.) In that case you can change the `key` prop of
   * the transition child as you change its content, this will cause
   * `TransitionGroup` to transition the child out and back in.
   */
  children: v.node,
  /**
   * A convenience prop that enables or disables appear animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  appear: v.bool,
  /**
   * A convenience prop that enables or disables enter animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  enter: v.bool,
  /**
   * A convenience prop that enables or disables exit animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  exit: v.bool,
  /**
   * You may need to apply reactive updates to a child as it is exiting.
   * This is generally done by using `cloneElement` however in the case of an exiting
   * child the element has already been removed and not accessible to the consumer.
   *
   * If you do need to update a child as it leaves you can provide a `childFactory`
   * to wrap every child, even the ones that are leaving.
   *
   * @type Function(child: ReactElement) -> ReactElement
   */
  childFactory: v.func
} : {};
Q.defaultProps = Vt;
const Ze = [
  "bottom-center",
  "bottom-left",
  "bottom-right",
  "top-center",
  "top-left",
  "top-right"
];
function Ht(e, a) {
  return e.reduce(
    (o, r) => (o[r.position || a].push(r), o),
    Ze.reduce((o, r) => (o[r] = [], o), {})
  );
}
const He = {
  left: "translateX(-100%)",
  right: "translateX(100%)",
  "top-center": "translateY(-100%)",
  "bottom-center": "translateY(100%)"
}, Bt = {
  left: "translateX(0)",
  right: "translateX(0)",
  "top-center": "translateY(0)",
  "bottom-center": "translateY(0)"
};
function Gt({
  state: e,
  maxHeight: a,
  position: o,
  transitionDuration: r
}) {
  const [n, t] = o.split("-"), i = t === "center" ? `${n}-center` : t, u = {
    opacity: 0,
    maxHeight: a,
    transform: He[i],
    transitionDuration: `${r}ms, ${r}ms, ${r}ms`,
    transitionTimingFunction: "cubic-bezier(.51,.3,0,1.21), cubic-bezier(.51,.3,0,1.21), linear",
    transitionProperty: "opacity, transform, max-height"
  }, l = {
    opacity: 1,
    transform: Bt[i]
  }, p = {
    opacity: 0,
    maxHeight: 0,
    transform: He[i]
  };
  return { ...u, ...{
    entering: l,
    entered: l,
    exiting: p,
    exited: p
  }[e] };
}
function Xt(e, a) {
  return typeof a == "number" ? a : a === !1 || e === !1 ? !1 : e;
}
const Ke = ft(
  ({ data: e, onHide: a, autoClose: o, ...r }, n) => {
    const { autoClose: t, message: i, ...u } = e, l = Xt(o, e.autoClose), p = Pe(-1), h = () => window.clearTimeout(p.current), g = () => {
      a(e.id), h();
    }, w = () => {
      typeof l == "number" && (p.current = window.setTimeout(g, l));
    };
    return _e(() => {
      e.onOpen?.(e);
    }, []), _e(() => (w(), h), [l]), /* @__PURE__ */ P.jsx(
      lt,
      {
        ...r,
        ...u,
        onClose: g,
        ref: n,
        onMouseEnter: h,
        onMouseLeave: w,
        children: i
      }
    );
  }
);
Ke.displayName = "@mantine/notifications/NotificationContainer";
var et = { root: "m_b37d9ac7", notification: "m_5ed0edd0" };
const Qt = B, Jt = {
  position: "bottom-right",
  autoClose: 4e3,
  transitionDuration: 250,
  containerWidth: 440,
  notificationMaxHeight: 200,
  limit: 5,
  zIndex: mt("overlay"),
  store: re,
  withinPortal: !0
}, Zt = it((e, { zIndex: a, containerWidth: o }) => ({
  root: {
    "--notifications-z-index": a?.toString(),
    "--notifications-container-width": at(o)
  }
})), G = tt((e, a) => {
  const o = nt("Notifications", Jt, e), {
    classNames: r,
    className: n,
    style: t,
    styles: i,
    unstyled: u,
    vars: l,
    position: p,
    autoClose: h,
    transitionDuration: g,
    containerWidth: w,
    notificationMaxHeight: N,
    limit: D,
    zIndex: M,
    store: A,
    portalProps: $,
    withinPortal: J,
    ...j
  } = o, I = rt(), c = Rt(A), U = gt(), ce = pt(), Z = Pe({}), oe = Pe(0), K = (I.respectReducedMotion ? ce : !1) ? 1 : g, z = ot({
    name: "Notifications",
    classes: et,
    props: o,
    className: n,
    style: t,
    classNames: r,
    styles: i,
    unstyled: u,
    vars: l,
    varsResolver: Zt
  });
  _e(() => {
    A?.updateState((X) => ({
      ...X,
      limit: D || 5,
      defaultPosition: p
    }));
  }, [D, p]), ht(() => {
    c.notifications.length > oe.current && setTimeout(() => U(), 0), oe.current = c.notifications.length;
  }, [c.notifications]);
  const fe = Ht(c.notifications, p), Y = Ze.reduce(
    (X, q) => (X[q] = fe[q].map(({ style: V, ...F }) => /* @__PURE__ */ P.jsx(
      Qt,
      {
        timeout: K,
        onEnter: () => Z.current[F.id].offsetHeight,
        nodeRef: { current: Z.current[F.id] },
        children: (le) => /* @__PURE__ */ P.jsx(
          Ke,
          {
            ref: (s) => {
              s && (Z.current[F.id] = s);
            },
            data: F,
            onHide: (s) => Ge(s, A),
            autoClose: h,
            ...z("notification", {
              style: {
                ...Gt({
                  state: le,
                  position: q,
                  transitionDuration: K,
                  maxHeight: N
                }),
                ...V
              }
            })
          }
        )
      },
      F.id
    )), X),
    {}
  );
  return /* @__PURE__ */ P.jsxs(vt, { withinPortal: J, ...$, children: [
    /* @__PURE__ */ P.jsx(ie, { ...z("root"), "data-position": "top-center", ref: a, ...j, children: /* @__PURE__ */ P.jsx(Q, { children: Y["top-center"] }) }),
    /* @__PURE__ */ P.jsx(ie, { ...z("root"), "data-position": "top-left", ...j, children: /* @__PURE__ */ P.jsx(Q, { children: Y["top-left"] }) }),
    /* @__PURE__ */ P.jsx(
      ie,
      {
        ...z("root", { className: Ie.classNames.fullWidth }),
        "data-position": "top-right",
        ...j,
        children: /* @__PURE__ */ P.jsx(Q, { children: Y["top-right"] })
      }
    ),
    /* @__PURE__ */ P.jsx(
      ie,
      {
        ...z("root", { className: Ie.classNames.fullWidth }),
        "data-position": "bottom-right",
        ...j,
        children: /* @__PURE__ */ P.jsx(Q, { children: Y["bottom-right"] })
      }
    ),
    /* @__PURE__ */ P.jsx(ie, { ...z("root"), "data-position": "bottom-left", ...j, children: /* @__PURE__ */ P.jsx(Q, { children: Y["bottom-left"] }) }),
    /* @__PURE__ */ P.jsx(ie, { ...z("root"), "data-position": "bottom-center", ...j, children: /* @__PURE__ */ P.jsx(Q, { children: Y["bottom-center"] }) })
  ] });
});
G.classes = et;
G.displayName = "@mantine/notifications/Notifications";
G.show = L.show;
G.hide = L.hide;
G.update = L.update;
G.clean = L.clean;
G.cleanQueue = L.cleanQueue;
G.updateState = L.updateState;
const Kt = () => /* @__PURE__ */ P.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "30",
    height: "30",
    fill: "none",
    viewBox: "0 0 30 30",
    children: [
      /* @__PURE__ */ P.jsx("g", { clipPath: "url(#clip0_116_3861)", children: /* @__PURE__ */ P.jsx(
        "path",
        {
          fill: "#0648FF",
          d: "M15 2.5C8.1 2.5 2.5 8.1 2.5 15S8.1 27.5 15 27.5 27.5 21.9 27.5 15 21.9 2.5 15 2.5zm-3.387 17.863l-4.488-4.488a1.245 1.245 0 010-1.762 1.245 1.245 0 011.762 0l3.613 3.6 8.6-8.6a1.245 1.245 0 011.762 0 1.245 1.245 0 010 1.762l-9.487 9.488a1.245 1.245 0 01-1.762 0z"
        }
      ) }),
      /* @__PURE__ */ P.jsx("defs", { children: /* @__PURE__ */ P.jsx("clipPath", { id: "clip0_116_3861", children: /* @__PURE__ */ P.jsx("path", { fill: "#fff", d: "M0 0H30V30H0z" }) }) })
    ]
  }
), en = () => /* @__PURE__ */ P.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "30",
    height: "30",
    fill: "none",
    viewBox: "0 0 30 30",
    children: [
      /* @__PURE__ */ P.jsx("g", { clipPath: "url(#clip0_957_35490)", children: /* @__PURE__ */ P.jsx(
        "path",
        {
          fill: "#8B1515",
          d: "M14.988 2.5C8.088 2.5 2.5 8.1 2.5 15s5.588 12.5 12.488 12.5C21.9 27.5 27.5 21.9 27.5 15S21.9 2.5 14.988 2.5zM15 25C9.475 25 5 20.525 5 15S9.475 5 15 5s10 4.475 10 10-4.475 10-10 10zm4.375-11.25a1.872 1.872 0 001.875-1.875A1.872 1.872 0 0019.375 10a1.872 1.872 0 00-1.875 1.875c0 1.037.837 1.875 1.875 1.875zm-8.75 0a1.872 1.872 0 001.875-1.875A1.872 1.872 0 0010.625 10a1.872 1.872 0 00-1.875 1.875c0 1.037.838 1.875 1.875 1.875zM15 16.875c-2.912 0-5.387 1.825-6.387 4.375h12.774c-1-2.55-3.474-4.375-6.387-4.375z"
        }
      ) }),
      /* @__PURE__ */ P.jsx("defs", { children: /* @__PURE__ */ P.jsx("clipPath", { id: "clip0_957_35490", children: /* @__PURE__ */ P.jsx("path", { fill: "#fff", d: "M0 0H30V30H0z" }) }) })
    ]
  }
), cn = G, fn = {
  show: (e) => {
    const a = e.variant ?? "info", o = {
      variant: "info",
      icon: /* @__PURE__ */ P.jsx(Kt, {})
    }, r = {
      variant: "error",
      icon: /* @__PURE__ */ P.jsx(en, {})
    };
    return L.show({
      ...e,
      ...a === "info" && o,
      ...a === "error" && r,
      ...a === "custom" && {}
    });
  },
  hide: L.hide,
  update: L.update,
  clean: L.clean,
  cleanQueue: L.cleanQueue,
  updateState: L.updateState
};
export {
  cn as Notifications,
  fn as notifications
};
